import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { GeographicalRegions } from '../../party/model/geographicalRegions.model';

@Injectable({
    providedIn: 'root'
})
export class GeographicalDataService extends DefaultDataService<GeographicalRegions> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService) {
        super('Geographical', http, httpUrlGenerator);
    }

    override getAll(): Observable<GeographicalRegions[]> {
        const url = this.urlProvider.getUrl(EndPoints.contactMechanisms_indexGeographicalRegions, undefined, undefined);
        return this.http
            .get(
                url,
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(res.body['geographicalRegions']);
                })
            );
    }
}
